/**
 * @fileoverview gRPC-Web generated client stub for stronachgroup.first.racehorse360
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.4.1
// 	protoc              v0.0.0
// source: stronachgroup/first/racehorse360/trainer_service.proto

/* eslint-disable */
// @ts-nocheck

const grpc = {};
grpc.web = require("grpc-web");

var google_api_annotations_pb = require("../../../google/api/annotations_pb.js");

var google_api_visibility_pb = require("../../../google/api/visibility_pb.js");

var stronachgroup_first_racehorse360_messages_pb = require("../../../stronachgroup/first/racehorse360/messages_pb.js");
const proto = {};
proto.stronachgroup = {};
proto.stronachgroup.first = {};
proto.stronachgroup.first.racehorse360 = require("./trainer_service_pb.js");

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.stronachgroup.first.racehorse360.TrainerServiceClient =
  function TrainerServiceClient(hostname, credentials, options) {
    if (!options) options = {};
    options.format = "text";

    /**
     * @private @const {!grpc.web.GrpcWebClientBase} The client
     */
    this.client_ = new grpc.web.GrpcWebClientBase(options);

    /**
     * @private @const {string} The hostname
     */
    this.hostname_ = hostname.replace(/\/+$/, "");
  };

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.stronachgroup.first.racehorse360.TrainerServicePromiseClient =
  function TrainerServicePromiseClient(hostname, credentials, options) {
    if (!options) options = {};
    options.format = "text";

    /**
     * @private @const {!grpc.web.GrpcWebClientBase} The client
     */
    this.client_ = new grpc.web.GrpcWebClientBase(options);

    /**
     * @private @const {string} The hostname
     */
    this.hostname_ = hostname.replace(/\/+$/, "");
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.GetTrainerRequest,
 *   !proto.stronachgroup.first.racehorse360.Trainer>}
 */
const methodDescriptor_TrainerService_GetTrainer =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.TrainerService/GetTrainer",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.GetTrainerRequest,
    stronachgroup_first_racehorse360_messages_pb.Trainer,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.GetTrainerRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.Trainer.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.GetTrainerRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.Trainer)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.Trainer>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.TrainerServiceClient.prototype.getTrainer =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.TrainerService/GetTrainer",
      request,
      metadata || {},
      methodDescriptor_TrainerService_GetTrainer,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.GetTrainerRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.Trainer>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.TrainerServicePromiseClient.prototype.getTrainer =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.TrainerService/GetTrainer",
      request,
      metadata || {},
      methodDescriptor_TrainerService_GetTrainer
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.ListTrainersRequest,
 *   !proto.stronachgroup.first.racehorse360.ListTrainersResponse>}
 */
const methodDescriptor_TrainerService_ListTrainers =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.TrainerService/ListTrainers",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.ListTrainersRequest,
    stronachgroup_first_racehorse360_messages_pb.ListTrainersResponse,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.ListTrainersRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.ListTrainersResponse.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.ListTrainersRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.ListTrainersResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.ListTrainersResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.TrainerServiceClient.prototype.listTrainers =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.TrainerService/ListTrainers",
      request,
      metadata || {},
      methodDescriptor_TrainerService_ListTrainers,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.ListTrainersRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.ListTrainersResponse>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.TrainerServicePromiseClient.prototype.listTrainers =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.TrainerService/ListTrainers",
      request,
      metadata || {},
      methodDescriptor_TrainerService_ListTrainers
    );
  };

module.exports = proto.stronachgroup.first.racehorse360;
